import { EventEmitter } from "./event-emitter";

const GeneralUtils = {
  sleepTime: (n) => new Promise((r) => setTimeout(() => r(), n)),
  showLoader: () => EventEmitter.dispatch('SHOW_LOADER'),
  hideLoader: () => EventEmitter.dispatch('HIDE_LOADER'),
};

export default GeneralUtils;
